<template>
    <div class="outlook common-card">
        <div class="card-title">
            <p>日程管理</p>
            <el-button type="text" style="margin-left: auto;" @click="routerHandle">更多></el-button>
        </div>
        <div class="outlook-content common-content">
            <div class="hidden-content outlook-main scroll_hidden" @mouseover="mymouseIn" @mouseout="mymouseOut">
                <template v-if="total>0">
                    <div class="outlook-item" v-for="item in tableData" :key="item.id" :class="setClass(item)">
                        <div class="item-data">
                            <div class="item-data--title" @click="editHandler(item)" :title="item.title">{{item.title}}</div>
                            <div class="item-data--cr">
                                <span class="cr-time" :title="`${item.startTime} ~ ${item.endTime}`">{{showTime(item)}}</span>
                                <span class="cr-address" :title="item.location">{{item.location}}</span>
                            </div>
                        </div>
                        <div class="item-btns">
                            <el-button type="text" @click="completeHandler(item)">完成</el-button>
                            <span>|</span>
                            <el-button type="text" @click="deleteHandle(item)">删除</el-button>
                        </div>
                    </div>
                </template>
                <div class="no-message" v-else>
                    <img :src="`${require('@/assets/images/nomessage.png')}`" alt="">
                    <p>无日程</p>
                </div>
            </div>
            <div class="outlook-btn" @click="addHandle">
                <i class="el-icon-plus"></i>添加一行数据
            </div>
        </div>
        <SchModal ref="SchModal" @on-sumit="sumitHandler"></SchModal>
    </div>
</template>

<script>
import SchModal from '@/components/SchModal';
import {
    apiwbschedulemanagementlist,
    apiwbschedulemanagementdelete,
    apiwbschedulemanagementupdateCompleteStatus
} from '@/server/new.js';
import dayjs from '@/utils/dayjs.js';
export default {
    components: {
        SchModal
    },
    data() {
        return {
            tableData: [],
            total: 0
        }
    },
    mounted() {
        this.apiwbschedulemanagementlist()
    },
    methods: {
        showTime(row) {
            let tempStart = row.startTime;
            let tempEnd = row.endTime;
            return `${dayjs(tempStart).format('MM-DD HH:mm')} ~ ${dayjs(tempEnd).format('MM-DD HH:mm')}`;
        },
        apiwbschedulemanagementlist() {
            apiwbschedulemanagementlist({
                page:1,
                rows:30,
                filter:{
					completeStatus:0
				}
            }).then(({data}) => {
                this.tableData = data.rows || [];
                this.total = data.total || 0;
            })
        },
        setClass(row) {
            let emergencyLevelEnum = {
                1: 'item-common',
                2: 'item-important',
                3: 'item-emergent'
            }
            return emergencyLevelEnum[row.emergencyLevel] || 'item-common'
        },
        editHandler(row) { //编辑
            this.$refs.SchModal.open(row.id);
        },
        sumitHandler() {
            this.apiwbschedulemanagementlist();
        },
        routerHandle() { //更多按钮
            this.$router.push({
                name: 'workday'
            })
        },
        addHandle() { //添加按钮
            this.$refs.SchModal.open();
        },
        completeHandler(row) { //完成按钮
            this.$confirm(`是否完成该条数据？`,'提示', {
                confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
            }).then(() => {
                apiwbschedulemanagementupdateCompleteStatus(row.id).then(({data}) => {
                    if(data.code === '1') {
                        this.$message({
                            type:'success',
                            message:'完成成功'
                        })
                        this.apiwbschedulemanagementlist();
                    }else {
                        this.$message({
                            type:'error',
                            message:data.msg
                        })
                    }
                })
            }).catch(() => {})
        },
        deleteHandle(row) { //删除按钮
            this.$confirm(`是否删除该条数据？`,'提示', {
                confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
            }).then(() => {
                apiwbschedulemanagementdelete(row.id).then(({data}) => {
                    if(data.code === '1') {
                        this.$message({
                            type:'success',
                            message:'删除成功'
                        })
                        this.apiwbschedulemanagementlist();
                    }else {
                        this.$message({
                            type:'error',
                            message:data.msg
                        })
                    }
                })
            }).catch(() => {})
        }
    },
}
</script>

<style lang="less" scoped>
.outlook {
    .outlook-content {
        .outlook-main {
            height: calc(100% - 40px - 20px);
            .outlook-item:hover{
              background-color: #F8F9Fc;
            }
            .outlook-item {
                position: relative;
                display: flex;
                align-items: center;
                padding: 10px 0;
                background-size: 45px 45px;
                &.item-important {
                    background-image: url('../../../../assets/images/home/icon-zhongyao.png');
                    background-repeat:  no-repeat;
                }
                &.item-emergent {
                    background-image: url('../../../../assets/images/home/icon-jinji.png');
                    background-repeat:  no-repeat;
                }
                &:after{
                    content: '';
                    width: 100%;
                    height: 1px;
                    background: #ebeef5;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                }
                .item-index {
                    width: 50px;
                    text-align: center;
                }
                .item-data {
                    // width: calc(100% - 100px);
                    width: 100%;
                    padding-left: 40px;
                    .item-data--title {
                        width: 95%;
                        // max-width: 210px;
                        font-weight: bold;
                        font-size: 14px;
                        line-height: 22px;
                        margin-bottom: 6px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        cursor: pointer;
                    }
                    .item-data--cr {
                        display: flex;
                        line-height: 22px;
                        align-items: center;
                        width: 95%;
                        span {
                            color: rgba(0,0,0,.45);
                            display: inline-block;
                            &.cr-time {
                                width: 205px;
                            }
                            &.cr-address {
                                width: calc(100% - 205px - 10px);
                                margin-left: 10px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }
                        }
                    }
                }
                &:hover {
                    .item-data {
                        width: calc(100% - 100px);
                    }
                    .item-btns {
                        display: flex;
                    }
                }
                .item-btns {
                    display: none;
                    align-items: center;
                    padding-right: 10px;
                    >span {
                        color: #EEEEEE;
                        margin: 0 8px;
                    }
                }
            }
        }
        .outlook-btn {
            border: 1px dashed #ebeef5;
            border-radius: 5px;
            text-align: center;
            padding: 10px 0;
            margin: 10px 20px 0;
            cursor: pointer;
            transition: .5s;
            &:hover {
                border-color: @--color-primary;
                color: @--color-primary;
            }
        }
    }
}
</style>